import React, { FC } from 'react';
import { Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { CurrencyInput, Form } from '~/components';
import { inputWidth } from '~/utils/filters';

export type AccountFiltersType = {
  number?: string;
  status?: string;
  alias?: string;
  currency?: string;
};

interface FiltersProps {
  onChange: (filters: AccountFiltersType) => void;
  form?: any;
  initialValues?: AccountFiltersType;
}

const AccountFilters: FC<FiltersProps> = ({ form, onChange, initialValues }) => {
  const { t } = useTranslation('accounts');

  const handleValuesChange = (_changed: any, values: Record<string, any>) => {
    onChange(values);
  };

  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleValuesChange}
      initialValues={initialValues}
    >
      <Form.Item name="status" style={{ marginBottom: 8 }}>
        <Select placeholder={t('status')} allowClear style={inputWidth}>
          <Select.Option value="ACTIVE">{t('status:ACTIVE')}</Select.Option>
          <Select.Option value="BLOCKED">{t('status:BLOCKED')}</Select.Option>
          <Select.Option value="CLOSED">{t('status:CLOSED')}</Select.Option>
          {/* Add more statuses as needed */}
        </Select>
      </Form.Item>
      <Form.Item name="number" style={{ marginBottom: 8 }}>
        <Input placeholder={t('accountNumber')} style={inputWidth} />
      </Form.Item>
      <Form.Item name="alias" style={{ marginBottom: 8 }}>
        <Input placeholder={t('alias')} style={inputWidth} />
      </Form.Item>
      <Form.Item name="currency" style={{ marginBottom: 8 }}>
        <CurrencyInput placeholder={t('currency')} style={inputWidth} />
      </Form.Item>
    </Form>
  );
};

export default AccountFilters;
